import React from "react";
import { Text as NText, ITextProps } from "native-base";

export const Text: React.FC<ITextProps> = (props) => {
  return <NText {...props} />;
};

export default Text;
